import React from 'react';
import { ReactComponent as BackgroundImage } from '../assets/home/hero_background.svg';
import { useI18n } from '../i18n/I18nContext';
import { routeIds } from '../i18n/routes';

function HeroHeader() {
  const { pathFor, t } = useI18n();

  return (
    <section id="hero-header" className="relative bg-gradient-to-r from-primary-200 to-primary-400 min-h-[50rem] content-center overflow-x-clip p-10">
      <BackgroundImage aria-hidden="true" data-ambient className="hero-art absolute bottom-[-50px] sm:left-[50%] opacity-20 sm:opacity-100 z-10" />
      <div className="flex max-w-[1200px] mx-auto relative sm:static pt-[6.25rem] z-20">
        <div className="hero-copy w-full sm:w-1/2 sm:pr-5">
          <h1 className="text-white text-4xl font-bold text-left uppercase">{t("home.hero.title")}</h1>
          <div className="text-white text-base font-bold text-left py-[2.25rem]" dangerouslySetInnerHTML={{__html: t("home.hero.text")}}></div>
          <div className="flex justify-center sm:justify-start">
            <a className="motion-button bg-accent text-white text-center font-bold rounded-full uppercase py-[1.25rem] px-[60px] transition duration-300 hover:opacity-50" href={pathFor(routeIds.contact)}>{t("common.contactUs")}</a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default HeroHeader;
